
import { motion } from 'framer-motion';
import TouchSlider from '../../../components/base/TouchSlider';

const contactDetails = [
  {
    icon: 'ri-phone-line',
    title: 'Telefon',
    items: [
      { text: '+48 600 978 050', href: 'tel:+48600978050', label: 'Janusz Gładysz — właściciel' },
      { text: '+48 790 788 033', href: 'tel:+48790788033', label: 'Konrad Komarski — kier. produkcji' },
      { text: '+48 790 333 565', href: 'tel:+48790333565', label: 'Biuro' },
    ],
  },
  {
    icon: 'ri-mail-line',
    title: 'Email',
    items: [
      { text: 'jgladysz@eureka.sanok.pl', href: 'mailto:jgladysz@eureka.sanok.pl', label: 'Dyrekcja' },
      { text: 'kkomarski@eureka.sanok.pl', href: 'mailto:kkomarski@eureka.sanok.pl', label: 'Produkcja' },
    ],
  },
  {
    icon: 'ri-map-pin-line',
    title: 'Lokalizacja',
    items: [
      {
        text: 'Zabłotce 146, 38-500 Sanok',
        href: 'https://maps.google.com/?q=Zab%C5%82otce+146+38-500+Sanok',
        label: 'Województwo podkarpackie, Polska',
      },
    ],
  },
  {
    icon: 'ri-time-line',
    title: 'Godziny pracy',
    items: [{ text: 'Pon — Pt: 7:00 — 15:00', href: '', label: 'Biuro i produkcja' }],
  },
];

function ContactCard({
  detail,
  index,
}: {
  detail: typeof contactDetails[0];
  index: number;
}) {
  return (
    <motion.div
      initial={{ opacity: 0, x: -20 }}
      whileInView={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.6, delay: index * 0.1 }}
      viewport={{ once: true }}
      className="bg-[#111111] border border-[#00E5FF]/10 p-4 sm:p-5 hover:border-[#00E5FF]/40 transition-all duration-500 group h-full"
    >
      <div className="flex items-start gap-3 sm:gap-4">
        <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-[#00E5FF]/10 border border-[#00E5FF]/30 flex-shrink-0 group-hover:bg-[#00E5FF]/20 transition-all duration-300">
          <i className={`${detail.icon} text-lg sm:text-xl text-[#00E5FF]`}></i>
        </div>
        <div className="flex-1 min-w-0">
          <h3
            className="text-white font-bold text-xs sm:text-sm mb-2"
            style={{ fontFamily: 'Orbitron, sans-serif' }}
          >
            {detail.title}
          </h3>
          <div className="space-y-2">
            {detail.items.map((item, idx) => (
              <div key={idx}>
                {item.href ? (
                  <a
                    href={item.href}
                    target={item.href.startsWith('http') ? '_blank' : undefined}
                    rel={item.href.startsWith('http') ? 'noopener noreferrer' : undefined}
                    className="text-[#00E5FF] text-xs sm:text-sm hover:underline cursor-pointer block truncate"
                    style={{ fontFamily: 'Inter, sans-serif' }}
                  >
                    {item.text}
                  </a>
                ) : (
                  <span
                    className="text-white text-xs sm:text-sm block"
                    style={{ fontFamily: 'Inter, sans-serif' }}
                  >
                    {item.text}
                  </span>
                )}
                <span
                  className="text-[#666666] text-[10px] sm:text-xs"
                  style={{ fontFamily: 'Inter, sans-serif' }}
                >
                  {item.label}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </motion.div>
  );
}

export default function ContactInfo() {
  return (
    <div>
      <div className="mb-6 sm:mb-8">
        <span
          className="text-[#00E5FF] text-[10px] sm:text-xs tracking-[0.2em] sm:tracking-[0.3em] uppercase font-semibold"
          style={{ fontFamily: 'Orbitron, sans-serif' }}
        >
          Dane kontaktowe
        </span>
        <h2
          className="text-xl sm:text-2xl font-bold text-white mt-2 sm:mt-3 leading-tight"
          style={{ fontFamily: 'Rajdhani, sans-serif' }}
        >
          Bezpośredni <span className="text-[#00E5FF]">Kontakt</span>
        </h2>
        <div className="h-[2px] w-16 bg-[#00E5FF] mt-3 sm:mt-4"></div>
      </div>

      {/* Desktop — stacked cards */}
      <div className="hidden sm:flex flex-col gap-4 sm:gap-6">
        {contactDetails.map((detail, index) => (
          <ContactCard key={index} detail={detail} index={index} />
        ))}
      </div>

      {/* Mobile — horizontal slider */}
      <div className="sm:hidden">
        <TouchSlider gap={12} showDots showArrows={false} itemClassName="w-[80vw]">
          {contactDetails.map((detail, index) => (
            <ContactCard key={index} detail={detail} index={index} />
          ))}
        </TouchSlider>
      </div>
    </div>
  );
}
